import "./contacts.css";
import BackBtn from "./Shared/BackBtn";
import { TextField, IconButton, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import backend from "../../../../../../../api";
import { setUserData } from "../../../../../../../redux-store/auth/actions";
import { useSnackbar } from "notistack";
import { motion, easeOut } from "framer-motion";

export default function EmergencyContactForm() {
  const { id } = useParams(); // undefined => add, else edit
  const { user } = useSelector(s => s.auth);
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const original = id !== undefined ? (user?.emergencyContacts?.[id] || {}) : {};
  const [name, setName] = useState(original.name || "");
  const [phone, setPhone] = useState(original.phone || "");
  const [saving, setSaving] = useState(false);

  // Helpers
  const isBlank = (s) => !s || !String(s).trim();
  const isValidPhone = (p) => /^\+?\d{7,15}$/.test(p); // 7-15 digits, optional leading +

  const save = async () => {
    // Validations
    if (isBlank(name)) {
      enqueueSnackbar("Please enter a contact name.", { variant: "warning" });
      return;
    }
    if (isBlank(phone)) {
      enqueueSnackbar("Please enter a phone number.", { variant: "warning" });
      return;
    }
    if (!isValidPhone(phone)) {
      enqueueSnackbar("Please enter a valid phone number (7-15 digits, optional +).", { variant: "warning" });
      return;
    }

    setSaving(true);
    try {
      const newContact = { name: name.trim(), phone: phone.trim() };
      const arr = [...(user?.emergencyContacts || [])];
      if (id !== undefined) arr[+id] = newContact;
      else arr.push(newContact);

      const { data } = await backend.put(`/api/user/${user._id}`, { emergencyContacts: arr });
      dispatch(setUserData({ ...user, ...data.data }));
      enqueueSnackbar("Emergency contact saved!", { variant: "success" });
      nav("/settings/profile/contacts");
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || "Error saving contact", { variant: "error" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <motion.div
      className="pf-wrap"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: easeOut }}
    >
      <BackBtn />
      <h2 className="pf-modal-title" style={{ textAlign: "left" }}>
        {id !== undefined ? "Edit" : "Add"} Emergency Contact
      </h2>

      <div className="pf-it-form">
        <TextField
          fullWidth
          size="small"
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          error={isBlank(name)}
          helperText={isBlank(name) ? "Name is required" : ""}
        />
        <TextField
          fullWidth
          size="small"
          label="Phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          error={isBlank(phone) || !isValidPhone(phone)}
          helperText={
            isBlank(phone)
              ? "Phone number is required"
              : !isValidPhone(phone)
              ? "Enter a valid phone number (7-15 digits)"
              : ""
          }
          sx={{ mt: 2 }}
        />

        <button className="pf-save" onClick={save} disabled={saving}>
          {saving ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Save"}
        </button>
      </div>
    </motion.div>
  );
}